import { Door, Window, Opening, GlassFront } from './main';
import { WallOpening } from '../WallOpening';
// tslint:disable-next-line:cyclomatic-complexity
export function createOpeningGeometryType(pRoomManager, pOpening, pType) {
    let topGeo = null;
    switch (pType) {
        case "Opening":
            topGeo = new Opening(pRoomManager, pOpening);
            break;
        case "Window":
            topGeo = new Window(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.ColumnCount = 1;
            topGeo.mOpening.setType("Window");
            break;
        case "WindowDouble":
            topGeo = new Window(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.ColumnCount = 2;
            topGeo.mOpening.setType("Window");
            break;
        case "Door":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.ColumnCount = 1;
            topGeo.mOpening.setType("Door");
            break;
        case "DoubleDoor":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.doorTypeDouble = true;
            topGeo.mOpening.setType("Door");
            break;
        case "GlassDoor":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.doorType = WallOpening.DoorTypes.glass;
            topGeo.mOpening.OpeningParams.doorTypeDouble = false;
            topGeo.mOpening.setType("Door");
            break;
        case "GlassDoubleDoor":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.doorType = WallOpening.DoorTypes.glass;
            topGeo.mOpening.OpeningParams.doorTypeDouble = true;
            topGeo.mOpening.setType("Door");
            break;
        case "GlassInlayDoor":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.doorType = WallOpening.DoorTypes.inlay;
            topGeo.mOpening.OpeningParams.doorTypeDouble = false;
            topGeo.mOpening.setType("Door");
            break;
        case "GlassInlayDoubleDoor":
            topGeo = new Door(pRoomManager, pOpening);
            topGeo.mOpening.OpeningParams.doorType = WallOpening.DoorTypes.inlay;
            topGeo.mOpening.OpeningParams.doorTypeDouble = true;
            topGeo.mOpening.setType("Door");
            break;
        case "GlassFront":
            return (new GlassFront(pRoomManager, pOpening));
        default:
            topGeo = null;
    }
    return (topGeo);
}
